import { Trans, useTranslation } from 'react-i18next';

import Twitter from '@/assets/v2/twitter.svg?react';
import { PRODUCT_NAME } from '@/shared/constance';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-footer-bg box-border flex w-full flex-col items-center justify-center gap-6 px-[28px] py-[76px] md:gap-8">
      <div className="flex w-full max-w-screen-lg flex-col items-center justify-center gap-6 md:gap-8">
        {/* Navigation Links */}
        <div className="flex w-full flex-col items-center gap-5  p-0 text-sm md:w-auto md:flex-row md:gap-9 md:text-base">
          {/* 政策链接组 */}
          <div className=" flex flex-row flex-wrap items-center justify-center gap-0 gap-y-5 md:gap-9">
            <a
              href="/policies/terms-of-use"
              className="can-hover:hover:opacity-70 text-content-primary can-hover:hover:text-footer-link-hover can-hover:hover:bg-white/10 md:can-hover:hover:bg-transparent  flex h-[22px] items-center justify-center gap-2 rounded-md px-3 py-2 font-normal no-underline transition-colors active:bg-white/20 md:min-h-0 md:rounded-none md:p-0"
              target="_blank"
            >
              <div
                className="flex size-2.5 basis-2.5 flex-col bg-current"
                style={{
                  mask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                  WebkitMask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                }}
              />
              {t('footer.termsOfService')}
            </a>
            <a
              href="/policies/privacy-policy"
              className="can-hover:hover:opacity-70 text-content-primary hover:text-footer-link-hover flex h-[22px]  items-center justify-center gap-2 rounded-md px-3 py-2 font-normal no-underline transition-colors hover:bg-white/10 active:bg-white/20 md:min-h-0 md:rounded-none md:p-0 md:hover:bg-transparent"
              target="_blank"
            >
              <div
                className="flex size-2.5 basis-2.5 flex-col bg-current"
                style={{
                  mask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                  WebkitMask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                }}
              />
              {t('footer.privacyPolicy')}
            </a>
            <a
              href="/policies/cookie-policy"
              className="can-hover:hover:opacity-70 text-content-primary hover:text-footer-link-hover flex h-[22px]  items-center justify-center gap-2  rounded-md px-3 py-2 font-normal no-underline transition-colors hover:bg-white/10 active:bg-white/20 md:min-h-0 md:rounded-none md:p-0 md:hover:bg-transparent"
              target="_blank"
            >
              <div
                className="flex size-2.5 basis-2.5 flex-col bg-current"
                style={{
                  mask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                  WebkitMask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                }}
              />
              {t('footer.cookiePolicy')}
            </a>

            <a
              href="https://www.codeflicker.ai/docs/"
              className="can-hover:hover:opacity-70 text-content-primary hover:text-footer-link-hover flex h-[22px] items-center justify-center gap-2 rounded-md px-3 py-2 font-normal no-underline transition-colors hover:bg-white/10 active:bg-white/20 md:min-h-0 md:rounded-none md:p-0 md:hover:bg-transparent"
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="flex size-2.5 basis-2.5 flex-col bg-current"
                style={{
                  mask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                  WebkitMask: "url('/assets/svg/nav-link-icon.svg') center / contain no-repeat",
                }}
              />
              {t('footer.docs')}
            </a>
          </div>

          <div className="bg-footer-divider hidden h-3.5 w-px basis-px md:block" />

          {/* 社交链接组 */}
          <div className="flex items-center justify-center gap-8 md:gap-9">
            <a
              href="https://x.com/CodeFlicker_ai"
              target="_blank"
              rel="noopener noreferrer"
              className="can-hover:hover:opacity-70 text-content-primary hover:text-footer-link-hover flex h-[22px]  items-center justify-center gap-2  rounded-md px-3 py-2 font-normal no-underline transition-colors hover:bg-white/10 active:bg-white/20 md:min-h-0 md:rounded-none md:p-0 md:hover:bg-transparent"
            >
              <Twitter />
              {t('footer.twitter')}
            </a>
            <a
              href="https://discord.gg/rVdpZS9D3C"
              target="_blank"
              rel="noopener noreferrer"
              className="can-hover:hover:opacity-70 text-content-primary hover:text-footer-link-hover flex h-[22px]  items-center justify-center gap-2  rounded-md px-3 py-2 font-normal no-underline transition-colors hover:bg-white/10 active:bg-white/20 md:min-h-0 md:rounded-none md:p-0 md:hover:bg-transparent"
            >
              <div
                className="size-[18px] basis-[18px] overflow-hidden bg-current"
                style={{
                  mask: "url('/assets/svg/discord-icon.svg') center / contain no-repeat",
                  WebkitMask: "url('/assets/svg/discord-icon.svg') center / contain no-repeat",
                }}
              />
              {t('footer.discord')}
            </a>
          </div>
        </div>

        {/* Copyright and Font Notice */}
        <div className="flex w-full flex-col items-center justify-between gap-4 text-[12px] leading-[1.3] md:text-sm">
          <div className="flex w-full flex-col items-center gap-4 md:w-[559px]">
            <div className="text-content-primary font-manrope min-w-[162px]  text-center font-light">
              {t('footer.copyright', { year, productName: PRODUCT_NAME })}
            </div>
          </div>
          <div className="bg-border-footer-split h-[0.6px] w-[240px]" />
          <div className="text-content-primary flex flex-col items-center text-center">
            <div className="mb-2 leading-normal opacity-80">{t('footer.notice')}</div>
            <div className="leading-normal opacity-80">
              <Trans
                i18nKey="footer.noticeContent1"
                components={{
                  googleLink: (
                    <a
                      href="https://fonts.google.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="can-hover:hover:text-footer-link-hover underline"
                    />
                  ),
                }}
              />
            </div>
            <div className="leading-normal opacity-80">
              <Trans
                i18nKey="footer.noticeContent2"
                components={{
                  licenseLink: (
                    <a
                      href="https://openfontlicense.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-footer-link-hover underline"
                    />
                  ),
                }}
              />
            </div>
            <div className="leading-normal opacity-80">
              <Trans
                i18nKey="footer.noticeContent3"
                components={{
                  fileLink: (
                    <a
                      href="https://fonts.google.com/specimen/Manrope/license"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-footer-link-hover underline"
                    />
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
